<ion-app>
  <ion-split-pane contentId="main-content" when="lg">
    <ion-menu contentId="main-content" type="overlay" class="glass-panel">
      <ion-header class="ion-no-border">
        <ion-toolbar class="transparent-toolbar" style="--padding-top: 40px; height: 120px;">
          <ion-title class="neon-textLarge" style="font-size: 1.4rem;">PEGASUS VENDOR</ion-title>
        </ion-toolbar>
      </ion-header>

      <ion-content class="glass-panel">
        <ion-list lines="none" class="transparent-list">
          <ion-item button routerLink="/tabs/home" routerDirection="root" detail="false" class="nav-item">
            <ion-icon slot="start" name="grid-outline"></ion-icon>
            <ion-label>Dashboard</ion-label>
          </ion-item>
          <ion-item button routerLink="/tabs/menu" routerDirection="root" detail="false" class="nav-item">
            <ion-icon slot="start" name="restaurant-outline"></ion-icon>
            <ion-label>Menu Management</ion-label>
          </ion-item>
          <ion-item button routerLink="/tabs/inventory" routerDirection="root" detail="false" class="nav-item">
            <ion-icon slot="start" name="cube-outline"></ion-icon>
            <ion-label>Inventory</ion-label>
          </ion-item>
          <ion-item button routerLink="/tabs/history" routerDirection="root" detail="false" class="nav-item">
            <ion-icon slot="start" name="time-outline"></ion-icon>
            <ion-label>Order History</ion-label>
          </ion-item>
          <ion-item button routerLink="/tabs/profile" routerDirection="root" detail="false" class="nav-item">
            <ion-icon slot="start" name="person-outline"></ion-icon>
            <ion-label>Profile</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>

    <div class="ion-page" id="main-content">
      <ion-router-outlet></ion-router-outlet>
    </div>
  </ion-split-pane>
</ion-app>
